import React, { useEffect, useState } from "react";
import { getGallery } from "../Service/Api";
import Slider from "react-slick";
import LazyLoad from "react-lazyload";

const Gallery = () => {
  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const topperData1 = await getGallery();
      const topperData = topperData1.filter(
        (item) => item.school === "NEKPUR" && item.category === "PhotoGallery",
      );
      setData(topperData || []); // Ensure data is always an array
    };
    fetchData();
  }, []);

  useEffect(() => {
    console.log("events_data", data[0]);
  }, [data]);

  const emptyArray = [
    {
      title: "Gallery Title",
      attachments:
        "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GISFNU/public/Images/gallery1.jpg",
    },
    {
      title: "Gallery Title",
      attachments:
        "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GISFNU/public/Images/gallery2.jpg",
    },
    {
      title: "Gallery Title",
      attachments:
        "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GISFNU/public/Images/gallery3.jpg",
    },
    {
      title: "Gallery Title",
      attachments:
        "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GISFNU/public/Images/gallery4.jpg",
    },
    {
      title: "Gallery Title",
      attachments:
        "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GISFNU/public/Images/gallery5.jpg",
    },
    {
      title: "Gallery Title",
      attachments:
        "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GISFNU/public/Images/gallery6.jpg",
    },
    {
      title: "Gallery Title",
      attachments:
        "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GISFNU/public/Images/gallery1.jpg",
    },
    {
      title: "Gallery Title",
      attachments:
        "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GISFNU/public/Images/gallery1.jpg",
    },
  ];

  const settings = {
    autoplay: true,
    infinite: true,
    autoplaySpeed: 2000,
    speed: 1000,
    slidesToShow: 6,
    slidesToScroll: 1,
    initialSlide: 0,
    arrows: false,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <>
      <div className="row">
        <Slider {...settings}>
          {data.length > 0
            ? data.map((item, index) => (
                <div className="item" key={index}>
                  <div className="galleryimg">
                    <div className="galleryimgbox">
                      <LazyLoad>
                        <img
                          src={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${item.attachments[0]}`}
                          className="img-fluid"
                          alt={item.title || "Gallery Image"}
                        />
                      </LazyLoad>
                      <div className="gallerydesc">
                        <h6>{item.title}</h6>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            : emptyArray.map((item, index) => (
                <div className="item" key={index}>
                  <div className="galleryimg">
                    <div className="galleryimgbox">
                      <LazyLoad>
                        <img
                          src={item.attachments}
                          className="img-fluid"
                          alt="Placeholder"
                        />
                      </LazyLoad>
                      <div className="gallerydesc">
                        <h6>{item.title}</h6>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
        </Slider>
      </div>
    </>
  );
};

export default Gallery;
